<template>
  <main class="full-height">
    <v-toolbar-side-icon @click.stop="redirectBack">
      <v-icon>arrow_back</v-icon>
    </v-toolbar-side-icon>
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout justify-center row wrap>
          <v-flex xs12 class="text-xs-center">
            <v-layout row wrap>
              <button
                type="button"
                class="button-return-filters"
                @click="$router.go(-1)"
              >
                <v-icon>arrow_back</v-icon>
              </button>
              <v-flex xs12 class="mb-4">
                <h2 class="font-weight-black">Recibos Encontrados</h2>
              </v-flex>

              <v-flex xs12>
                <v-card class="form-card">
                  <div class="layout-table">
                    <v-data-table
                      :items="recibos"
                      :headers="headers"
                      :loading="loading"
                      :no-data-text="msgNoResults"
                      :pagination.sync="pagination"
                      :rows-per-page-items="[10, 20]"
                      :rows-per-page-text="'Linhas por página'"
                      :custom-sort="customSort"
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td class="text-xs-center">
                            {{ props.item.numeroRecibo }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.favorecido }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.dataRegistro }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.dataProvisionamento }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.dataPagamento }}
                          </td>
                          <td class="text-xs-center">
                            {{ verificaStatus(props.item.status) }}
                          </td>

                          <td class="text-xs-center">
                            <v-icon
                              color="#061d45"
                              @click="
                                downloadPdf(
                                  props.item.idLancamento,
                                  props.item.favorecido,
                                  props.item.numeroRecibo
                                )
                              "
                              dark
                              >picture_as_pdf</v-icon
                            >
                          </td>

                          <td class="text-xs-center">
                            <v-icon
                              color="#061d45"
                              @click="
                                downloadExtratoXls(
                                  props.item.idLancamento,
                                  props.item.favorecido,
                                  props.item.numeroRecibo
                                )
                              "
                              dark
                              >insert_drive_file</v-icon
                            >
                          </td>
                        </tr>
                      </template>

                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="error"
                        icon="warning"
                      >
                        Sua pesquisa não encontrou resultados.
                      </v-alert>
                    </v-data-table>
                  </div>
                  <div class="text-footer">
                    <p>
                      Prezado corretor, informamos que para gerarmos extrato
                      referente a comissões a receber é necessário possuir um
                      acúmulo mínimo de R$200,00”. “Para receber as comissões
                      gentileza gerar o último extrato acumulado e enviar
                      juntamente com a nota fiscal já emitida para o endereço
                      notasfiscais@grupojnp.com.br”.
                    </p>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script lang="js">
import { base64ToArrayBuffer, saveByteArray } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";
import moment from "moment";

export default {
  name: "ListarRecibos",
  mixins: [ViewMixin],
  data: () => ({
    loading: false,
    msgNoResults: "Nenhum recibo encontrado para os filtros selecionados",
    headers: [
      {
        text: "Nr. Recibo",
        align: "center",
        value: "numeroRecibo",
        sortable: true,
      },
      {
        text: "Favorecido",
        align: "center",
        value: "favorecido",
        sortable: false,
      },
      {
        text: "Data Registro",
        align: "center",
        value: "dataRegistro",
        sortable: true,
      },
      {
        text: "Data Provisionamento",
        align: "center",
        value: "dataProvisionamento",
        sortable: true,
      },
      {
        text: "Data Pagamento",
        align: "center",
        value: "dataPagamento",
        sortable: true,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Recibo",
        align: "center",
        value: "recibo",
        sortable: false,
      },
      {
        text: "Extrato",
        align: "center",
        value: "extrato",
        sortable: false,
      },
    ],
    pagination: {},
    loaded: true,
    loading: false,
    recibos: [],
  }),
  methods: {
    verificaStatus(status){
      if(!status || status == null || status == ''){
        return '-'
      }else if(status.toLowerCase() == 'cancelado'){
        return 'Quitado'
      }
      return status;
    },
    async getTickets() {
      try {
        const me = await this.$store.dispatch("GET_ME");
        this.recibos = await this.$store.dispatch("GET_TICKETS", { me });

        if (this.recibos.length === 0) {
          this.setErrorModal(this.$strings.noTicketsFound);
        }
      } catch (e) {
        this.setErrorModal(this.$strings.defaultOperationError);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async downloadPdf(idLancamento, favorecido, numeroRecibo) {
      const params = {
        action: "GET_PDF",
        prefix: "recibo_comissao",
        formato: "pdf",
        idLancamento,
        favorecido,
        numeroRecibo,
      };

      await this.baseDispatch(params);
    },

    async downloadExtratoXls(idLancamento, favorecido, numeroRecibo) {
      const params = {
        action: "GET_EXTRATO_XLS",
        prefix: "extrato_comissao",
        formato: "xls",
        idLancamento,
        favorecido,
        numeroRecibo,
      };

      await this.baseDispatch(params);
    },

    async baseDispatch(params) {
      this.showLoadingIndicator();

      const {
        action,
        idLancamento,
        favorecido,
        numeroRecibo,
        prefix,
        formato,
      } = params;

      try {
        const arr = await this.$store.dispatch(action, { idLancamento });
        const byteArr = base64ToArrayBuffer(arr);
        saveByteArray(
          `${prefix}_nr${numeroRecibo}_${favorecido}`,
          byteArr,
          formato
        );
      } catch (e) {
        this.setErrorModal(this.$strings.defaultOperationError);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async init() {
      this.showLoadingIndicator();
      await this.getTickets();
      this.loaded = true;
      this.handleLimit();
    },

    handleLimit() {
      if (this.recibos.length == 500) {
        this.setErrorModal(this.$strings.ticketsLimitWarning);
      }
    },

    customSort(items, index, isDesc) {
      const DD_MM_YYYY = "DD/MM/YYYY";

      items.sort((a, b) => {
        if (
          ["dataRegistro", "dataProvisionamento", "dataPagamento"].includes(
            index
          )
        ) {
          if (!isDesc) {
            if (!a[index]) return -1;
            if (!b[index]) return 1;

            return moment(a[index], DD_MM_YYYY).isBefore(
              moment(b[index], DD_MM_YYYY)
            )
              ? -1
              : 1;
          } else {
            if (!a[index]) return 1;
            if (!b[index]) return -1;

            return moment(a[index], DD_MM_YYYY).isSameOrAfter(
              moment(b[index], DD_MM_YYYY)
            )
              ? -1
              : 1;
          }
        } else if (index === "numeroRecibo") {
          const numero1 = parseInt(a[index]);
          const numero2 = parseInt(b[index]);

          if (!isDesc) {
            return numero1 < numero2 ? -1 : 1;
          } else {
            return numero2 < numero1 ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });

      return items;
    },
  },

  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .full-height {
    .container {
      padding: 0 40px;
    }

    .v-content {
      padding: 50px 0 0 80px !important;
    }
  }

  .button-return-filters {
    transition: all 0.3s;
    position: absolute;
    border-radius: 50%;
    background-color: #f1e41e;

    i {
      padding: 5px;
      font-size: 2rem;
      color: #061d45;
    }

    &:hover {
      background-color: #061d45;

      i {
        color: #fff;
      }
    }
  }

  @media (max-width: 480px) {
    .button-return-filters {
      position: relative;
    }
  }

  .layout-table {
    height: auto;
    max-height: 620px;
    overflow: auto;
  }

  .text-footer {
    display: flex;
    padding: 20px;
    height: auto;
    background-color: #fff;
    margin-top: 1px;
    border: 1px solid rgba($color: #ddd, $alpha: 0.2);
    text-align: justify;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    word-break: break-word;

    p {
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/ExtratosRecibos/Recibos/Listar.vue